import { Box, Button, CircularProgress } from "@material-ui/core";
import { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { usePoolMonitoringContext } from "src/context/monitoring/poolMonitoringContext";
import { useProviderContext } from "src/ether-utils/context/providerContext";
import { encodePackageData, getContractEditPool } from "src/hooks/useContractEditPool";
import useLowerAddressParam from "src/hooks/useLowerAddressParam";
import useNotify from "src/hooks/useNotify";
import { toFixed } from "src/services/utils";
import StyledTextField from "../components/StyledTextField";
import { defaultConfig } from "./ReserveParameterDialog";

export default function TabReserveFactor({ asset }) {
  const mounted = useRef(false);
  const { pool } = useLowerAddressParam();
  const { currentProvider, wallet } = useProviderContext();
  const { data } = usePoolMonitoringContext();
  const [reserveFactor, setReserveFactor] = useState(asset.risk.reserveFactor);
  const [helperText, setHelperText] = useState(null);
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const { errorNotify, successNotify } = useNotify();

  const handleConfirm = async () => {
    setLoading(true);
    const contractEditPool = getContractEditPool(wallet.signer);
    try {
      const dataEncode = await encodePackageData(currentProvider, "setReserveFactor", [
        asset.address,
        toFixed(Number(reserveFactor) * 1000),
      ]);
      const tx = await contractEditPool.submitTransaction(data[pool].overview.providerId, dataEncode);
      await tx.wait();
      successNotify("Transaction Successfully");
      history.push(`/pool-monitoring/${pool}?action=pending`);
      window.location.reload(false);
    } catch (error) {
      console.error(error);
      errorNotify(error?.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (mounted.current) {
      if (reserveFactor == null || reserveFactor == "") setHelperText("This field is required");
      else if (reserveFactor < 0 || reserveFactor > 1)
        setHelperText("This field must be less than 1 and greater than 0");
    }
    mounted.current = true;
  }, [reserveFactor]);

  return (
    <Box mt={4}>
      <StyledTextField
        textProps={{
          ...defaultConfig,
          label: "Reserve Factor",
          value: reserveFactor,
          onChange: (e) => setReserveFactor(e.target.value),
          error: helperText != null,
          helperText: helperText,
        }}
        rootProps={{ mb: 2 }}
        info="The reserve factor allocates a share of the protocol's interests to a collector contract as a reserve for the ecosystem."
      />
      <Box>
        <Button
          disabled={helperText != null || reserveFactor == asset.risk.reserveFactor || loading}
          fullWidth
          variant="contained"
          color="primary"
          onClick={handleConfirm}
        >
          {!loading ? "Confirm" : <CircularProgress size={24} />}
        </Button>
      </Box>
    </Box>
  );
}
